export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const PLAN_TYPES = {
    ONLINE: "online",
    OFFLINE: "offline"
}

export const BTN_SAVE = "Save";
export const BTN_CANCEL = "Cancel";
export const BTN_EDIT = "Edit";
export const EMAIL_INVALID_ERROR = "Please enter a valid email address.";

